import { createContentPropTypes } from '../../../helpers/content';

const content = {
	okButtonLabel: 'Ok',
	title: "You've added all your favourites",
	body: "You can only set up to 30 favourite accounts. If you'd still like to add this account as a favourite, you can unselect another account by clicking or tapping the star.",
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
